import React from 'react';
import { Link } from 'react-router-dom';
import { Heart, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-[#1A3A28] to-[#2D5F3F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* About Section */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_charity-impact-hub/artifacts/mea68gvu_my-project-page-1%20%282%29.png" 
                alt="Bridge of Hope Foundation"
                className="h-20 w-auto brightness-0 invert opacity-90 hover:opacity-100 transition-opacity duration-300"
              />
            </Link>
            <p className="text-sm text-gray-300 mb-4">
              Connecting UK generosity with life-changing mobility equipment for vulnerable individuals in Nigeria.
            </p>
            <p className="text-xs text-gray-400">
              Registered Charity No. {contactInfo.charityNumber}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-[#D4AF37]">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Home</Link></li>
              <li><Link to="/about" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">About Us</Link></li>
              <li><Link to="/our-work" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Our Work</Link></li>
              <li><Link to="/get-involved" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Get Involved</Link></li>
              <li><Link to="/transparency" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Transparency & Governance</Link></li>
              <li><Link to="/contact" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Contact</Link></li>
            </ul>
          </div>

          {/* Get Involved */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-[#D4AF37]">Get Involved</h4>
            <ul className="space-y-2">
              <li><Link to="/get-involved?tab=donate" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Make a Donation</Link></li>
              <li><Link to="/get-involved?tab=volunteer" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Volunteer</Link></li>
              <li><Link to="/get-involved?tab=partner" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Become a Partner</Link></li>
              <li><Link to="/get-involved?tab=trustee" className="text-sm text-gray-300 hover:text-white transition-colors duration-200">Join as Trustee</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4 text-[#D4AF37]">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#D4AF37]" />
                <span className="text-sm text-gray-300">
                  {contactInfo.address.line2}<br />
                  {contactInfo.address.city} {contactInfo.address.postcode}
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-4 h-4 flex-shrink-0 text-[#D4AF37]" />
                <a href={`mailto:${contactInfo.email}`} className="text-sm text-gray-300 hover:text-white transition-colors duration-200">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-4 h-4 flex-shrink-0 text-[#D4AF37]" />
                <a href={`tel:${contactInfo.phone}`} className="text-sm text-gray-300 hover:text-white transition-colors duration-200">
                  {contactInfo.phone}
                </a>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex items-center space-x-3 mt-4">
              <a href={contactInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-[#D4AF37] p-2 rounded-lg transition-colors duration-200">
                <Facebook className="w-4 h-4" />
              </a>
              <a href={contactInfo.social.twitter} target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-[#D4AF37] p-2 rounded-lg transition-colors duration-200">
                <Twitter className="w-4 h-4" />
              </a>
              <a href={contactInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-[#D4AF37] p-2 rounded-lg transition-colors duration-200">
                <Instagram className="w-4 h-4" />
              </a>
              <a href={contactInfo.social.linkedin} target="_blank" rel="noopener noreferrer" className="bg-white/10 hover:bg-[#D4AF37] p-2 rounded-lg transition-colors duration-200">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-400">
              © {currentYear} Bridge of Hope Foundation. All rights reserved.
            </p>
            <div className="flex items-center space-x-6">
              <Link to="/privacy" className="text-sm text-gray-400 hover:text-white transition-colors duration-200">Privacy Policy</Link>
              <Link to="/terms" className="text-sm text-gray-400 hover:text-white transition-colors duration-200">Terms of Use</Link>
              <Link to="/cookies" className="text-sm text-gray-400 hover:text-white transition-colors duration-200">Cookie Policy</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
